/**
 * Size Selector for Custom Collection
 * Handles size selection and add to cart functionality
 */

(function() {
  'use strict';

  function initSizeSelector() {
    const sizeSelectors = document.querySelectorAll('.ProductItem__SizeSelector');
    
    sizeSelectors.forEach(selector => {
      const sizeOptions = selector.querySelectorAll('.ProductItem__SizeOption');
      const addToCartBtn = selector.querySelector('.ProductItem__AddToCart');
      const productItem = selector.closest('.ProductItem');
      let isFirstHover = true;
      
      // Handle Add to Cart button (for products without variants)
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Don't proceed if the button is disabled (sold out)
          if (this.disabled) {
            return;
          }
          
          // Get the variant ID
          const variantId = this.getAttribute('data-variant-id');
          
          if (variantId) {
            // Add to cart
            addToCart(variantId, this);
          }
        });
        
        // No need for hover logic for Add to Cart button
        return;
      }
      
      // Set first available variant as selected on hover (for size selectors)
      if (productItem && sizeOptions.length > 0) {
        productItem.addEventListener('mouseenter', function() {
          if (isFirstHover) {
            // Find first available size option
            const firstAvailableOption = Array.from(sizeOptions).find(opt => !opt.disabled);
            
            if (firstAvailableOption) {
              // Set as selected
              firstAvailableOption.classList.add('ProductItem__SizeOption--selected');
            }
            isFirstHover = false;
          }
        }, { once: false });
      }
      
      sizeOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Don't proceed if the button is disabled (sold out)
          if (this.disabled) {
            return;
          }
          
          // Remove selected class from all options in this selector
          sizeOptions.forEach(opt => opt.classList.remove('ProductItem__SizeOption--selected'));
          
          // Add selected class to clicked option
          this.classList.add('ProductItem__SizeOption--selected');
          
          // Get the variant ID for this size
          const variantId = this.getAttribute('data-variant-id');
          
          if (variantId) {
            // Add to cart
            addToCart(variantId, this);
          }
        });
      });
      
      // Reset selection when mouse leaves the product item
      if (productItem && sizeOptions.length > 0) {
        productItem.addEventListener('mouseleave', function() {
          // Reset selected state
          sizeOptions.forEach(opt => opt.classList.remove('ProductItem__SizeOption--selected'));
          isFirstHover = true; // Reset for next hover
        });
      }
    });
  }
  
  /**
   * Add item to cart using Shopify AJAX API
   */
  function addToCart(variantId, buttonElement) {
    // Show loading state
    const originalText = buttonElement.textContent;
    buttonElement.style.opacity = '0.5';
    buttonElement.disabled = true;
    
    // Prepare the data
    const formData = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };
    
    // Add to cart via Shopify AJAX API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    })
    .then(data => {
      // Update cart count
      updateCartCount();
      
      // Open cart drawer
      openCartDrawer();
      
      // Reset button state
      buttonElement.style.opacity = '1';
      buttonElement.disabled = false;
      
      // Trigger cart update event for theme
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      
      // Reset button state
      buttonElement.style.opacity = '1';
      buttonElement.disabled = false;
      
      // Show error message
      alert('Sorry, there was an error adding this item to your cart. Please try again.');
    });
  }
  
  /**
   * Update cart count in header
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count in header
        const cartCountElements = document.querySelectorAll('.Header__CartCount');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }
  
  /**
   * Open the cart drawer
   */
  function openCartDrawer() {
    // Find the cart drawer trigger button
    const cartDrawerTrigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    
    if (cartDrawerTrigger) {
      // Trigger click to open drawer
      cartDrawerTrigger.click();
    } else {
      // Fallback: directly manipulate the drawer
      const cartDrawer = document.getElementById('sidebar-cart');
      if (cartDrawer) {
        cartDrawer.setAttribute('aria-hidden', 'false');
      }
    }
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeSelector);
  } else {
    initSizeSelector();
  }
  
  // Re-initialize when new products are loaded via Load More button
  document.addEventListener('collection:productsLoaded', initSizeSelector);
})();

